import {Injectable} from '@angular/core';
import {BaseDirectory, createDir, exists, readBinaryFile, readDir} from '@tauri-apps/api/fs';
import {appDataDir, basename, extname, sep} from '@tauri-apps/api/path';
import {DomSanitizer} from '@angular/platform-browser';
import {open} from '@tauri-apps/api/shell';
import {fs} from '@tauri-apps/api';
import {FileObj, LocalStorageService, SnackBarService} from '@customcoding/shared';
import {watch} from 'tauri-plugin-fs-watch-api';
import {TauriService} from './tauri.service';
import {metadata} from 'tauri-plugin-fs-extra-api';
import {HttpClient} from '@angular/common/http';
import {platform} from '@tauri-apps/api/os';
import * as fastxml from 'fast-xml-parser';
import {PatientService} from './patient.service';
import {firstValueFrom, forkJoin, Observable} from 'rxjs';
import {Folder} from '../models/folder';
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";

interface LocalFile {
	path: string;
	createdAt?: Date;
	modifiedAt?: Date;
	downloadedAt?: Date;
	kind?: string; // status for CRUD,
	patient_id?: number;
	file_id?: number;
	contentType?: string;

}

@Injectable({
	providedIn: 'root'
})
export class TauriFilesystemService {


	downloadedFiles: LocalFile[] = [];
	uniquePaths: any;
	lastSyncedAt: Date;
	rootPath: string;
	private uploadDebounceTimers = new Map<string, any>();
	private pendingUploads = new Set<string>();

	excludedFilesTypes = /^(?!.*(?:\/|^)\.(?![^\/]+\.[a-zA-Z0-9]+$))(?!.*\/desktop\.ini$)(?!.*\/thumbs\.db$)(?!.*\/.DS_Store$)(?!.*\/icon\r$)(?!.*\/~\$.*)(?!.*\.tmp$)(?!.*\.wbk$)(?!.*\.asd$)(?!.*\.lnk$)(?!.*\~lock\.).*\.(pdf|docx?|xlsx?|pptx?|txt|jpg|jpeg|png|gif|mp4|mov|avi|mp3|wav|zip|rar|tar|gz|7z)$/i;


	kindTypes = ['Any', 'AnyContinuous'];

	constructor(
		private sanitizer: DomSanitizer,
		private tauri: TauriService,
		private http: HttpClient,
		private storageService: LocalStorageService,
		private patientService: PatientService,
		private snackbar: SnackBarService,
		private translate: TranslateService,
	) {
		MoConsole.log('tauri service init');
		this.uniquePaths = new Set<string>();
		this.lastSyncedAt = new Date(); // TODO --> we should save this variable inside the localStorage

		if (tauri.isDesktopApp()) {

			this.downloadedFiles = this.storageService.get('downloadedFiles') ?? [];

			MoConsole.log("list all paths inside cloud folder:");
			this.parseFilesFromFolder().then(() => {
				this.initFileWatcher();
			})

		}
		this.rootPath = this.storageService.get('LAB_FOLDER_PATH');
	}

	/*
	this.initFileWatcher2();

			}

			initFileWatcher2(){

			 //   const { invoke } = require('@tauri-apps/api/call');

					const watcher = chokidar.watch('path/to/watched/files', {
							ignored: /(^|[\/\\])\../, // ignore dotfiles
							persistent: true,
					});

					watcher.on('all', (event,path) => {
							MoConsole.log("file changed, event = ",event);

							MoConsole.log("file changed, path = ",path);

					});


			}
	*/
	async initFileWatcher() {

		const basePath = await appDataDir();

		// can also watch an array of paths

		const stopWatching = await watch(
			basePath,
			(event: any) => {
				//  const { kind,path} = event[0];

				let kind;
				let path;


				let isIncluded = false;

				MoConsole.log('BASIC ___ file watched event = ', event);
				// MoConsole.log("meta path = ",path);
				MoConsole.log("uniquePaths = ", this.uniquePaths);

				event.forEach((e) => {

					MoConsole.log("e.path:", e.path);
					// || this.kindTypes.includes(e.kind)
					if (this.uniquePaths.has(e.path)) {

						MoConsole.log("matched");
						isIncluded = true;
						path = e.path;

					} else {
						MoConsole.log("not matched");
					}

					// MoConsole.log("path not existing or kind not matching!", {kind:kind, path:path});
				});

				if (!isIncluded) {

					MoConsole.log('path not existing or kind not matching!', event);

					return;
				}

				// check if file is really existing and ignore if not (workaround for tmp files e.g. MSWord)
				// this.checkPathExists(path).then(() =>{
				/*
				if(!this.uniquePaths.has(path) || !this.kindTypes.includes(kind)){
						MoConsole.log("path not existing or kind not matching!", {kind:kind, path:path});

						return;
				}

				 */


				metadata(path).then(meta => {

					MoConsole.log('meta: ', meta);
					this.updateDownloadedFileData({path, modifiedAt: meta.modifiedAt, createdAt: meta.createdAt});
				});

				// })

			},
			{recursive: true, delayMs: 2000},
		);

		// MoConsole.log("stopWathcing = ", stopWatching)

		/*
						const stopRawWatcher = await watchImmediate(
								[ basePath+"cloud"],
								(event) => {
										const { type, paths, attrs } = event;
										MoConsole.log("IMMEDIATE ___ file wachted event = ", event);
								},
								{recursive: true},
						);

		 */
	}


	/*
	async openFile() {

			MoConsole.log("testpath:", this.testPath);
			await open(this.testPath);
	}

	*/
	readXmlToJson(xml: string) {
		const parser = new fastxml.XMLParser();
		return parser.parse(xml);
	}

	getXMLFromUint8Array(file: Uint8Array) {
		const decoder = new TextDecoder();
		const xmlData = decoder.decode(file);
		return this.readXmlToJson(xmlData);
	}

	extractRegistrationNumberFromXml(xmlData: any) {
		return xmlData?.File?.Record?.Header?.SSNPatient ?? xmlData?.AdherantSECUline?.Matricule;
	}

	isUploadDateOlderThanModifyDate(uploadDate: string, xmlData: any) {
		return false;
	}

	extractPatientNameFromXml(xmlData: any) {
		const firstName = xmlData?.File?.Record?.Body?.Patient?.Person?.FirstName;
		const lastName = xmlData?.File?.Record?.Body?.Patient?.Person?.LastName;
		const fullName = firstName && lastName ? `${firstName} ${lastName}` : this.extractRegistrationNumberFromXml(xmlData);
		return fullName;
	}
	saveFailedUploadFile({ xmlData, fileName, path, lab, reason}) {
		const failedUploadFiles = this.storageService.get('failedUploadFiles') ?? [];
		const existingFile = failedUploadFiles.find((file) => file.fileName === fileName);
		if (!existingFile) {
			const file = {
				fileName,
				patient: this.extractPatientNameFromXml(xmlData),
				lab,
				path,
				reason,
				date: Date.now(),
			};
			failedUploadFiles.push(file);
			this.storageService.saveData('failedUploadFiles', failedUploadFiles);
			this.tauri.failedUploads.set(failedUploadFiles);
		}
	}
	removeFailedUploadFile(fileName: string) {
		const failedUploadFiles = this.storageService.get('failedUploadFiles') ?? [];
		const existingFileIndex = failedUploadFiles.findIndex((file) => file.fileName === fileName);
		if (existingFileIndex !== -1) {
			failedUploadFiles.splice(existingFileIndex, 1);
			this.storageService.saveData('failedUploadFiles', failedUploadFiles);
			this.tauri.failedUploads.set(failedUploadFiles);
			MoConsole.log('removed failed upload file', fileName);
		} else {
			MoConsole.log('nothing to remove from failed upload files', fileName);
		}
	}

	async getLaboratoryFolderLocalFiles() {
		// TODO: Assuming there is no nested folders
		const path = this.storageService.get('LAB_FOLDER_PATH');
		const entries = await readDir(path, {recursive: true});
		return entries.filter((entry) => entry.name.endsWith('.xml'));
	}

	getPatientFolderFiles(newerThan: string = null): Observable<any> {
		if (newerThan) {
			return this.http.get('/api/scap/patients/cloud/doctor-files?newer-than=' + newerThan);
		} else {
			return this.http.get('/api/scap/patients/cloud/doctor-files');
		}
	}

	async offlineSyncLabFolder() {
		const newerThan = this.storageService.get('filesLastChecked');
		if (!newerThan) {
			this.storageService.saveData('filesLastChecked', moment().format('YYYY-MM-DD HH:mm'));
		}

		const patientFiles = await this.getPatientFolderFiles(newerThan).toPromise();
		const labFolderFiles = await this.getLaboratoryFolderLocalFiles();

		const newlyUploadLabFiles = labFolderFiles.filter((labFile) => {
			const alreadyUploaded = patientFiles.find((patientFile: FileObj) => patientFile.originalName === labFile.name);
			return !alreadyUploaded;
		});
		if (newlyUploadLabFiles.length > 0) {
			for (const uploadedFile of newlyUploadLabFiles) {
				await this.uploadLabFiles(uploadedFile.path);
			}
		}
	}

	async watchLabFolderChanges() {
		const path = this.storageService.get('LAB_FOLDER_PATH');
		MoConsole.log('start watch for lab folder path', path);
		await watch(
			path,
			async (event) => {
				MoConsole.log({event});
				for (let i = 0; i < event.length; i++) {
					const {path: filePath} = event[i];
					const extension = await extname(filePath);
					MoConsole.log({extension});
					if (extension !== 'xml') {
						continue;
					}
					await this.uploadLabFiles(filePath);
				}
			},
			{recursive: true},
		);

	}


	validateGermanMatriculeNumber(matriculeNumber: string): boolean {
		matriculeNumber = Number(matriculeNumber).toString();
		MoConsole.log('matriculeNumber = ', matriculeNumber);
		// Check if it's exactly 13 digits
		if (!/^\d{13}$/.test(matriculeNumber)) {
			return false;
		}

		// Extract the date portion (first 8 digits, assuming format: YYYYMMDD)
		const year = parseInt(matriculeNumber.substring(0, 4), 10);
		const month = parseInt(matriculeNumber.substring(4, 6), 10);
		const day = parseInt(matriculeNumber.substring(6, 8), 10);

		// Create a date object and check if it's valid
		const date = new Date(year, month - 1, day);

		// Check if the date is valid by comparing the components
		if (
			date.getFullYear() !== year ||
			date.getMonth() !== month - 1 ||
			date.getDate() !== day
		) {
			return false;
		}

		// Check if the date is reasonable (e.g., not in the future and not too old)
		const currentDate = new Date();
		if (date > currentDate || year < 1900) {
			return false;
		}

		return true;
	}

	async uploadLabFiles(filePath: string) {
		try {
			MoConsole.log('start upload lab file', filePath);
			const rootFolder = this.storageService.get('LAB_FOLDER_PATH');
			const filePathWithoutRootSplit = filePath.split(rootFolder + '/');
			const filePathWithoutRoot = filePathWithoutRootSplit[1].split('/');
			MoConsole.log({filePathWithoutRoot});
			const fileName = await basename(filePath);
			const isFileAdded = await exists(filePath);
			if (isFileAdded) {
				const fileContent = await readBinaryFile(filePath);
				const fileContentToXML = this.getXMLFromUint8Array(fileContent);
				const registrationNumber = this.extractRegistrationNumberFromXml(fileContentToXML);
				if (registrationNumber) {
					const isValidRegistrationNumber = this.validateGermanMatriculeNumber(registrationNumber);
					if (!isValidRegistrationNumber) {
						MoConsole.log('Invalid registration number:', registrationNumber);
						this.saveFailedUploadFile({
							fileName,
							path: filePath,
							xmlData: fileContentToXML,
							lab: '',
							reason: 'scap.filesystem.upload.invalid_registration_number',
						});
						return;
					}
					const patient = await firstValueFrom(this.patientService.all({
						filters: {
							registration_number: registrationNumber,
						}
					}));
					if (patient.length > 0) {
						// using http directly due to circular dependency
						const patientFolders = await (this.http.get<Folder[]>(`/api/scap/patient/${patient[0].id}/cloud`)).toPromise();
						// TODO: Find better way of checking for LABOR_<DOC_NAME>
						const doctorFolder = patientFolders.find((folder) => {
							const splitFolderName = folder.name.split('_');
							const nonUserFolder = !isNaN(Number(splitFolderName[0])) || splitFolderName?.length === 1;
							return !nonUserFolder;
						});
						MoConsole.log({doctorFolder, filePath, filePathWithoutRootSplit});
						const doctorFirstName = doctorFolder.name.split('_')[0];
						const doctorLaboratoryFolder = doctorFolder.children
							.find((doctorFolderChild) => doctorFolderChild.key === `LABOR_${doctorFirstName}`);
						const contents = await readBinaryFile(filePath);
						const blob = new Blob([contents], {type: 'application/octet-stream'});
						const file = new File([blob], fileName, {type: 'application/octet-stream'});
						const formData = new FormData();
						formData.append('file', file);

						// const fileExists = (doctorLaboratoryFolder?.files ?? []).find((docFile) => docFile.originalName === fileName);
						const fileExists = filePathWithoutRoot.length === 1 ? doctorLaboratoryFolder
							?.files.find(file => file.originalName === filePathWithoutRoot[0]) : doctorLaboratoryFolder.children
							.find(folder => folder.name === (filePathWithoutRoot[0] || 'Labor'))
							?.files.find(file => file.originalName === filePathWithoutRoot[1]);
						MoConsole.log({fileExists});
						if (!fileExists) {
							let doctorLaboratoryFolderId = doctorLaboratoryFolder.id;
							if (filePathWithoutRoot[0] !== '' && filePathWithoutRoot?.length > 1) {
								// TODO: We are assuming it is only one folder after the root folder
								// TODO: i.e <Root>/Lab A/<xml or pdf file>
								const nestedFolder = filePathWithoutRoot[0];
								// Check first if folder has already been created
								const existingNestedFolder = doctorLaboratoryFolder.children.find((folder) => folder.name === nestedFolder);
								if (existingNestedFolder) {
									doctorLaboratoryFolderId = existingNestedFolder.id;
								} else {
									// 	we create the folder inside the doctor folder and get the folder id
									// TODO: Need for setting permissions with limited roles?
									const payload = {
										name: nestedFolder,
										parentFolder_id: doctorLaboratoryFolderId,
									};
									const nestedFolderResponse: any = await (this.http.post(`/api/scap/patient/${patient[0].id}/cloud/folder`, payload))
										.toPromise().catch((error) => {
											MoConsole.log({error});
											this.saveFailedUploadFile({
												fileName,
												path: filePath,
												xmlData: fileContentToXML,
												lab: nestedFolder,
												reason: 'scap.filesystem.upload.create_folder_failed',
											});
										});
									doctorLaboratoryFolderId = nestedFolderResponse.id;
								}
							}
							const uploadRequests = [
								this.http.post(`/api/scap/patient/${patient[0].id}/cloud/folder/${doctorLaboratoryFolderId}/file`, formData)
							];

							const pdfFileName = fileName.replace('.xml', '.pdf');
							const pdfFilePath = filePath.replace(fileName, pdfFileName);
							const pdfExists = await exists(pdfFilePath);
							if (pdfExists) {
								const pdfContents = await readBinaryFile(pdfFilePath);
								const pdfBlob = new Blob([pdfContents], {type: 'application/pdf'});
								const pdfFile = new File([pdfBlob], pdfFileName, {type: 'application/pdf'});
								const pdfFormData = new FormData();
								pdfFormData.append('file', pdfFile);
								uploadRequests.push(this.http
									.post(
										`/api/scap/patient/${patient[0].id}/cloud/folder/${doctorLaboratoryFolderId}/file`,
										pdfFormData));
							}
							await (forkJoin(uploadRequests))
								.toPromise().catch((error) => {
									MoConsole.log({error});
									this.saveFailedUploadFile({
										fileName,
										path: filePath,
										xmlData: fileContentToXML,
										lab: filePathWithoutRoot[0],
										reason: 'scap.filesystem.upload.upload_file_failed',
									});
								});
						} else {
							formData.append('_method', 'PATCH');
							await firstValueFrom(this.http.post(`/api/scap/patient/${patient[0].id}/cloud/file/${fileExists.id}`, formData));
						}
						MoConsole.log('uploaded successfully', {patient, doctorLaboratoryFolder, doctorFolder});
						this.removeFailedUploadFile(fileName);
					} else {
						MoConsole.log(`unsuccessful uploading file ${filePath}. Patient does not exist`);
						this.saveFailedUploadFile({
							fileName,
							path: filePath,
							xmlData: fileContentToXML,
							lab: filePathWithoutRoot[0],
							reason: 'scap.filesystem.upload.patient_not_found',
						});
					}
				} else {
					MoConsole.log(`unsuccessful uploading file ${filePath}. Registration does not exist`);
					this.saveFailedUploadFile({
						fileName,
						path: filePath,
						xmlData: fileContentToXML,
						lab: filePathWithoutRoot[0],
						reason: 'scap.filesystem.upload.missing_registration_number',
					});
				}
			}
		} catch (error) {
			MoConsole.log('uploadLabFiles error: ', error);
		}
	}

	async downloadBlobFile(blob: any, file: FileObj, patient_id: number) {


		MoConsole.log('downloadBlobFile file:', file);
		//MoConsole.log('downloadBlobFile local path:', path);

		const platformName = await platform();
		MoConsole.log('platform = ', platformName);
		MoConsole.log('sep:', sep);

		const basePath = await appDataDir();
		const filename = file.originalName; // encodeURIComponent(file.originalName);
		//  MoConsole.log("filename ==", filename);
		const path = `${basePath}cloud${sep}${file.id}${sep}${filename}`;
		const contents = await blob.arrayBuffer();


		const folderExisting = await this.checkExists(`cloud${sep}${file.id}`);
		// MoConsole.log("existing? ", folderExisting);
		if (!folderExisting) {
			// MoConsole.log("create folder with id = ", file.id);
			await this.createFolder(`cloud${sep}${file.id}`);
		} else {
			// MoConsole.log("folder existing")
		}

		//  MoConsole.log("write file...");

		await fs.writeBinaryFile(`cloud${sep}${file.id}${sep}${file.originalName}`, contents, {dir: BaseDirectory.AppData});

		// MoConsole.log( patient_id);
		// MoConsole.log("open file path = " , path);
		open(path).then(() => {
			this.addOrIgnore({
				path,
				modifiedAt: null,
				createdAt: null,
				downloadedAt: new Date(),
				file_id: file.id,
				patient_id,
				contentType: file.mimeType
			});

			MoConsole.log('all uniqueParts: ');
			MoConsole.log(this.uniquePaths);
		});

	}

	async getFilesForUpload() {

		MoConsole.log('currentRef Date = ', this.lastSyncedAt);

		const filesForUpload = this.downloadedFiles.filter((f) => f.modifiedAt > this.lastSyncedAt && f.createdAt != null);

		MoConsole.log('files, ready for update: ', filesForUpload);

		filesForUpload.forEach((f) => {


			const fileName = f.path.match(/[\\\/]([^\\\/]+)$/)?.[1] || '';
			MoConsole.log('filename :::::', fileName);
			MoConsole.log('upload file object:', f);

			if (this.pendingUploads.has(f.path)) {
				MoConsole.log('upload already running, skip debounce:', f.path);
				return;
			}

			const existingTimer = this.uploadDebounceTimers.get(f.path);
			if (existingTimer) {
				clearTimeout(existingTimer);
			}

			const timer = setTimeout(() => {
				this.uploadDebounceTimers.delete(f.path);
				this.pendingUploads.add(f.path);

				MoConsole.log('filename before reading from disk: ', fileName);
				MoConsole.log('file object before upload: ', f);
				MoConsole.log('reading changed file from watched path: ', f.path);

				readBinaryFile(f.path).then((localFile) => {


					this.getBlob(localFile, f).then((blob) => {
						const formdata = new FormData();
						formdata.append('file', blob, fileName);
						formdata.append('_method', 'PATCH');

						MoConsole.log(formdata);

						this.http.post(`/api/scap/patient/${f.patient_id}/cloud/file/${f.file_id}`, formdata).subscribe({
							next: () => {
								this.lastSyncedAt = new Date();
								this.pendingUploads.delete(f.path);
								this.snackbar.showSuccessDialog(this.translate.instant('scap.filesystem.snackbar.success.patch'));
							},
							error: (err) => {
								this.pendingUploads.delete(f.path);
								MoConsole.log('failed to patch file', err);
								this.snackbar.showServerError(this.translate.instant('scap.filesystem.snackbar.error.patch'), err);
							}
						});
					}).catch((err) => {
						this.pendingUploads.delete(f.path);
						MoConsole.log('failed to create blob from changed local file', {
							path: f.path,
							file: f,
							err,
						});
					});
				}).catch((err) => {
					this.pendingUploads.delete(f.path);
					MoConsole.log('failed to read changed local file', {
						path: f.path,
						file: f,
						err,
					});
				});
			}, 2500);

			this.uploadDebounceTimers.set(f.path, timer);

			MoConsole.log('all downloaded files = ');
			MoConsole.log(this.downloadedFiles);
		});

	}

	async getBlob(localFile: any, f): Promise<Blob> {

		MoConsole.log('typeof localFile = ', typeof localFile);
		// ArrayBuffer -> Blob
		// letvar uint8Array  = new Uint8Array([1, 2, 3]);
		const blob = new Blob([localFile], {type: f.contentType});

		return blob;

		/*const arrayBuffer = localFile.buffer;
		const blob = new Blob([arrayBuffer], {type: f.contentType});

		return blob;
		*/
		/*
		const blobAgain = new Blob(

				[new Buffer(localFile.toString(), 'base64')],
				{
						type: f.contentType
				}
		);
		const str = await blobAgain.text();
		MoConsole.log("str:::",str);
return blobAgain;
*/
		//   let buffer = new ArrayBuffer(32);
		// return new Blob([localFile].buffer, {type: f.contentType});
	}

	addOrIgnore(file: LocalFile) {


		//TODO: remove files from disk if not existing on server side (db).
		// add if not there:

		MoConsole.log("downloadedFiles:::", this.downloadedFiles);
		MoConsole.log("uniquePatch:::", this.uniquePaths);


		const alreadyDownloaded = !!this.downloadedFiles.find(f => f.path === file.path);
		MoConsole.log("alreadyDownloaded?:::", alreadyDownloaded);

		if (!this.uniquePaths.has(file.path)) {
			// Value is not a duplicate, add it to the array and the Set
			this.uniquePaths.add(file.path);
		}
		if (!alreadyDownloaded) {

			this.downloadedFiles.push(file);
			this.storageService.saveData('downloadedFiles', this.downloadedFiles);

		} else {
			const index = this.downloadedFiles.findIndex(f => f.path === file.path);
			this.downloadedFiles[index].createdAt = null;
			// check the last modified date and update if needed:
			// if(file.downloadedAt >)

		}
	}

	updateDownloadedFileData(file: LocalFile) {

		MoConsole.log("watched file = ", file);
		MoConsole.log("downloadedFiles before:", this.downloadedFiles);

		if (!this.uniquePaths.has(file.path)) {
			// TODO: the first case is only possible if the file was added manually or if the data is not correct synchronized before

		} else {
			const resultIndex = this.downloadedFiles.findIndex(f => file.path == f.path);
			// MoConsole.log("resultIndex: ", resultIndex);
			if (resultIndex == -1) {
				return;
			}

			const result = this.downloadedFiles[resultIndex];
			if (result.createdAt == null) {
				MoConsole.log('createAt is null');
				result.modifiedAt = file.modifiedAt;
				result.createdAt = file.createdAt; // set modifiedAt + createdAt
				this.downloadedFiles[resultIndex] = result;
				this.storageService.saveData('downloadedFiles', this.downloadedFiles);


				return; // abort, because it's called directly after file creation

			} else {
				MoConsole.log('else case!');
				result.modifiedAt = file.modifiedAt; // update only modifiedAt
				this.downloadedFiles[resultIndex] = result;
				this.storageService.saveData('downloadedFiles', this.downloadedFiles);

			}

			MoConsole.log('downloadedFiles after:', this.downloadedFiles);

			// TODO: maybe its better to run this function periodically e.g. each 1 minute, to check for all files, changed between the ref date and the modified date
			this.getFilesForUpload();
		}

	}

	/*
			downloadFile(url: string) {

					MoConsole.log("download file (tauri)");

					//let url = "https://www.rust-lang.org/logos/rust-logo-512x512.png";
					appDataDir().then(path => {

							MoConsole.log("path::", path);


							invoke('downloadFile', {url: url, destination: path + 'cloud'}).then((response) => {
									const fileName = url.match(/\/([^/]+)$/)?.[1] || "";

									MoConsole.log("filename test:", fileName);

								 // this.testPath = path + 'cloud/' + fileName;
									//this.openFile();
									MoConsole.log("response:::", response);
							})
					})

			}
	*/


	/* TESTING + PLAYGROUND */

	async checkExists(name) {

		return await exists(name, {dir: BaseDirectory.AppData});

	}

	async checkPathExists(name) {

		return await exists(name);

	}

	async createFolder(name: string = 'tauri_test_folder') {
		await createDir(name, {dir: BaseDirectory.AppData, recursive: true});
		//  await createDir(name, { dir: BaseDirectory.Download, recursive: true });

	}


	async parseFilesFromFolder(name: string = 'cloud'): Promise<void> {

		const entries = await readDir(name, {dir: BaseDirectory.AppData, recursive: true});
		MoConsole.log('-----start list content:');
		await this.processEntries(entries);
		MoConsole.log('-----end list content:');
	}

	async readFolderContent(name: string = 'cloud') {

		const entries = await readDir(name, {dir: BaseDirectory.AppData, recursive: true});
		MoConsole.log('-----start list content:');
		this.uniquePaths = new Set();
		await this.processEntries(entries);
		MoConsole.log('-----end list content:');

	}

	async processEntries(entries: any[]): Promise<void> {

		await Promise.all(
			entries.map(async (entry) => {


				if (this.excludedFilesTypes.test(entry.path)) {
					MoConsole.log(`Entry: ${entry.path}`);
					this.uniquePaths.add(entry.path);
				} else {
					MoConsole.log(`Entry: ${entry.path} (ignored)`);

				}
				if (entry.children && entry.children.length > 0) {
					await this.processEntries(entry.children); // Await recursive calls
				}
			})
		);
	}

	async getAllFilesAndFolders() {
		const rootPath = this.storageService.get('LAB_FOLDER_PATH');
		const entries = await readDir(rootPath, {recursive: true});
		MoConsole.log('entries',entries);
		const filesAndFolders = this.processFolderFileEntries(entries);
		MoConsole.log('filesAndFolders',filesAndFolders);
		return filesAndFolders;
	}

	processFolderFileEntries(entries: any[], parentFolder: string = ''): any[] {
		let result = [];
		for (const entry of entries) {
			//TODO use regex for excludedFilesTypes
			if (entry.name === '.DS_Store') {
				continue;
			}
			if (entry.children) {
				result = result.concat(this.processFolderFileEntries(entry.children, entry.name));
			} else {
				result.push({
					fileName: entry.name,
					folderName: parentFolder || null,
				});
			}
		}
		return result;
	}

	getFolderByName(folderName: string): Observable<Folder> {
		return this.http.get<Folder>(`/api/scap/patient/cloud/folder`, {
			params: {
				name: folderName,
			}
		});
	}

	// async initialFoldersFilesSync() {
	// 	const rootPath = this.storageService.get('LAB_FOLDER_PATH');
	// 	const allFilesAndFolders = await this.getAllFilesAndFolders();
	// 	let xmlFiles = allFilesAndFolders.filter((entry) => entry.fileName.endsWith('.xml'));
	//
	// 	const patientFiles = await this.getPatientFolderFiles().toPromise();
	//
	// 	xmlFiles = xmlFiles.filter((labFile) => {
	// 		const alreadyUploaded = patientFiles.find((patientFile: FileObj | any) => patientFile.originalName === labFile.fileName && patientFile.pivot.name === labFile.folderName);
	// 		return !alreadyUploaded;
	// 	});
	// 	MoConsole.log({xmlFiles, patientFiles});
	//
	// 	const batchSize = 10; // Adjust batch size as needed
	// 	const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
	//
	// 	for (let i = 0; i < xmlFiles.length; i += batchSize) {
	// 		const batch = xmlFiles.slice(i, i + batchSize);
	// 		await Promise.all(batch.map(async (entry) => {
	// 			const fullPath = entry.folderName ? `${rootPath}/${entry.folderName}/${entry.fileName}` : `${rootPath}/${entry.fileName}`;
	// 			await this.uploadLabFiles(fullPath);
	// 		}));
	// 		await delay(1000); // Delay of 1 second between batches
	// 	}
	// }

	async initialFoldersFilesSync() {

		const patientFiles = await firstValueFrom(this.getPatientFolderFiles());
		const allFilesAndFolders = await this.getAllFilesAndFolders();
		let xmlFiles = allFilesAndFolders.filter((entry) => entry.fileName.endsWith('.xml'));

		MoConsole.log('files length before filtering', xmlFiles.length);

		xmlFiles = await this.filterFiles(xmlFiles, patientFiles);

		MoConsole.log('files length after filtering', xmlFiles.length);
		MoConsole.log({ xmlFiles, patientFiles });

		const batchSize = 10; // Adjust batch size as needed
		const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

		for (let i = 0; i < xmlFiles.length; i += batchSize) {
			const batch = xmlFiles.slice(i, i + batchSize);
			await Promise.all(batch.map(async (entry) => {
				const fullPath = entry.folderName
					? `${this.rootPath}/${entry.folderName}/${entry.fileName}`
					: `${this.rootPath}/${entry.fileName}`;
				await this.uploadLabFiles(fullPath);
			}));
			await delay(1000); // Delay of 1 second between batches
		}
	}


	async filterFiles(xmlFiles: any[], patientFiles: any[]) {
		const filteredFiles = await Promise.all(
			xmlFiles.map(async (labFile) => {
				const alreadyUploaded: FileObj = patientFiles.find(
					(patientFile: FileObj | any) =>
						patientFile.originalName === labFile.fileName &&
						patientFile.pivot.name === labFile.folderName
				);

				if (alreadyUploaded) {
					MoConsole.log('already uploaded', alreadyUploaded);
					MoConsole.log('labFile', labFile);

					const fullPath = labFile.folderName
						? `${this.rootPath}/${labFile.folderName}/${labFile.fileName}`
						: `${this.rootPath}/${labFile.fileName}`;

					try {
						const fileMetadata = await metadata(fullPath);
						MoConsole.log('metadata', moment(fileMetadata.modifiedAt).toJSON(), moment(alreadyUploaded.updated_at?? alreadyUploaded.created_at).toJSON());
						const result = moment(fileMetadata.modifiedAt).isAfter(moment(alreadyUploaded.updated_at?? alreadyUploaded.created_at));
						MoConsole.log('result', result);
						return result
					} catch (error) {
						MoConsole.error('Failed to get metadata:', error);
						return false;
					}
				} else {
					MoConsole.log('alreadyUploaded', alreadyUploaded);
					return true;
				}
			})
		);

		return xmlFiles.filter((_file, index) => filteredFiles[index]);
	}
}
